import React, { useEffect } from 'react';

import { observer } from 'mobx-react';
import { Button, Container, LbPagination } from '@infoods/lifebase-ui';
import AddRoundedIcon from '@mui/icons-material/AddRounded';

import classes from './NgzRecipes.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { EmptyList, PageTitle } from '../../../shared/components/ui-components';
import { recipesListStore } from '../../stores/recipesListStore';
import { TitleRow } from './TitleRow/TitleRow';
import { RecipeRow } from './RecipeRow/RecipeRow';

const NgzRecipes = observer(() => {
  const { recipesList, filterMethods, getRecipesList, setDefaultValues } =
    recipesListStore;
  const {
    isShowPlaceholder,
    isSearchUsed,
    totalElements,
    elementsPerPage,
    getPaginationProps,
  } = filterMethods;

  useEffect(() => {
    getRecipesList();

    return setDefaultValues;
  }, []);

  return (
    <Container>
      <PageTitle title={`Recipes (${totalElements})`}>
        <Button
          href="#!/add-recipe"
          variant="contained"
          size="medium"
          startIcon={<AddRoundedIcon />}
        >
          Add New Recipe
        </Button>
      </PageTitle>
      <div className={classes.recipesTable}>
        <TitleRow />
        {recipesList.map((recipe) => (
          <RecipeRow key={recipe.id} recipe={recipe} />
        ))}
      </div>
      <EmptyList
        show={isShowPlaceholder}
        isSearch={isSearchUsed}
        description="There are no recipes"
      />
      <LbPagination
        variant="outBox"
        className={classes.pagination}
        {...getPaginationProps()}
        totalElements={totalElements}
        elementsPerPage={elementsPerPage}
      />
    </Container>
  );
});

angularizeWithProviders(NgzRecipes, 'ngzRecipes', {});
